// Created by hejikun on 2018/7/30 0025.
let state = {
  insurances: [],
  insurance: {},
  relations: [],
  plans: []
}

const actions = {}

const getters = {}

const mutations = {}

export default {
  state,
  mutations,
  actions,
  getters
}
